"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageStudioEventType = void 0;
var ImageStudioEventType;
(function (ImageStudioEventType) {
    ImageStudioEventType["Connect"] = "CONNECT";
    ImageStudioEventType["Disconnect"] = "DISCONNECT";
    ImageStudioEventType["ImageSave"] = "IMAGE_SAVE";
})(ImageStudioEventType || (exports.ImageStudioEventType = ImageStudioEventType = {}));
//# sourceMappingURL=ImageStudioEventType.js.map